import { useBrand } from '@/contexts/brand/BrandContext';

import type { OtpStrategy } from './types';

// gloss
export const useOtpStrategy = (): OtpStrategy | null => {
  const { brand, isLoading } = useBrand();

  if (isLoading || !brand?.uuid) {
    return null;
  }

  return {
    type: 'otp',
    primaryColor: brand.brandConfig?.primaryColor ?? undefined,
  };
};
